import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que hacer ejercicio?',
    a: 'No es necesario durante los primeros 14 días.'
  }, {
    q: '¿Puedo tomar café?',
    a: 'Sí, el café negro es tu aliado en este protocolo.'
  }, {
    q: '¿Es difícil de seguir?',
    a: 'Si podés comer carne y vegetales, podés hacer esto.'
  }, {
    q: '¿Voy a pasar hambre?',
    a: 'No, el plan prioriza la saciedad total.'
  }, {
    q: '¿Sirve si tengo diabetes o hipertensión?',
    a: 'El plan baja la inflamación, pero siempre consultá a tu médico antes de cambios drásticos.'
  }, {
    q: '¿Qué pasa después de los 14 días?',
    a: 'Te damos una guía para mantener los resultados sin esfuerzo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-12 text-center uppercase" data-id="element-12">
          Preguntas <span className="text-brand-orange" data-id="element-13">Frecuentes</span>
        </h2>
        <div className="space-y-4" data-id="element-14">
          {faqs.map((faq, index) => <div key={index} className="bg-dark-bg border border-gray-800 rounded-lg overflow-hidden transition-all duration-300" data-id="element-15">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} aria-expanded={openIndex === index} data-id="element-16">
                <span className="font-oswald text-xl font-medium uppercase pr-4" data-id="element-17">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-brand-orange flex-shrink-0" data-id="element-18" /> : <ChevronDown className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-19" />}
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-20">
                <p className="font-inter text-gray-400 text-lg" data-id="element-21">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}